import transitions from "./Transitions.module.scss";

export default transitions;
